import { buildHreflangAlternates, buildSiteUrl, getLanguageFromPath } from './polylang';

/** Default NO/EN pairs when Polylang translations are missing on a static page. */
const FALLBACK_HREFLANG_PAIRS = {
  kontakt: { no: '/kontakt', en: '/en/contact' },
  'om-oss': { no: '/om-oss', en: '/en/about-us' },
};

/**
 * @param {import('next/router').NextRouter['asPath']} asPath
 * @param {{ uri?: string, language?: { code?: string }, translations?: Array<{ uri?: string, language?: { code?: string } }> } | null | undefined} pageNode
 * @param {'kontakt' | 'om-oss'} pageKey
 */
export function getDispatchedPageSeo(asPath, pageNode, pageKey) {
  const { code, locale } = getLanguageFromPath(asPath);
  const fallback = FALLBACK_HREFLANG_PAIRS[pageKey];
  const canonicalPath =
    pageNode?.uri || (code === 'en' ? fallback.en : fallback.no);
  const canonicalUrl = buildSiteUrl(canonicalPath);

  let hreflangAlternates = buildHreflangAlternates(pageNode);
  if (!hreflangAlternates.length && fallback) {
    hreflangAlternates = [
      { hrefLang: 'no', href: buildSiteUrl(fallback.no) },
      { hrefLang: 'en', href: buildSiteUrl(fallback.en) },
      { hrefLang: 'x-default', href: buildSiteUrl(fallback.no) },
    ];
  }

  const homeLabel = code === 'en' ? 'Home' : 'Hjem';
  const homePath = code === 'en' ? '/en' : '/';
  const pageLabel =
    pageKey === 'kontakt'
      ? code === 'en'
        ? 'Contact'
        : 'Kontakt'
      : code === 'en'
        ? 'About us'
        : 'Om oss';

  return {
    code,
    locale,
    canonicalPath,
    canonicalUrl,
    hreflangAlternates,
    breadcrumbs: [
      { label: homeLabel, path: homePath },
      { label: pageLabel, path: canonicalPath },
    ],
  };
}
